export const RoleType = {
    INDUSTRY: 'INDUSTRY',
    LEADER: 'LEADER'
}